<template lang="html">
  <label class="custom-trigger" :class="{ disabled: disabled }">
    <input
      type="checkbox"
      :disabled="disabled"
      :checked="isChecked"
      :value="value"
      @click="change"
    />

    <span class="custom-trigger__slider custom-trigger__round"></span>
  </label>
</template>

<script>
  export default {
    name: 'CustomTrigger',

    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      value: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      isChecked() {
        return this.value;
      }
    },

    methods: {
      change() {
        this.$emit('change', !this.value);
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.custom-trigger {
  position: relative;
  display: inline-block;
  width: 40px;
  min-width: 40px;
  height: 20px;
  margin-bottom: 0;
  font-size: 11.7px !important;
}

.custom-trigger input {
  display: none;
}

.custom-trigger__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #7f7f7f;
  transition: 0.4s, background-size 0s, background-position 0s;
}

.disabled .custom-trigger__slider {
  cursor: not-allowed;
  opacity: 0.3;
}

.custom-trigger__slider:before {
  position: absolute;
  content: '';
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .custom-trigger__slider {
  background-color: $green;
  background-position: 20% center;
  background-repeat: no-repeat;
  background-size: 13px;
}

input:checked + .custom-trigger__slider:before {
  content: '';
  transform: translateX(100%);
  left: 6px;
  background-color: white;
}

.custom-trigger__slider.custom-trigger__round {
  border-radius: 10px;
}

.custom-trigger__slider.custom-trigger__round:before {
  border-radius: 10px;
}
</style>
